const PartnerCard = ({ partner }) => {
  return (
    <div className="relative flex flex-col sm:flex-row items-center sm:items-start bg-white p-4 sm:p-6 rounded-xl shadow-md border border-gray-200">
      {partner.premium && (
        <div class="ribbon">
          PREMIUM
        </div>
      )}

      <img
        src={partner.logo}
        alt={partner.name}
        className="w-28 h-28 sm:w-40 sm:h-40 object-contain mb-4 sm:mb-0 sm:mr-6"
      />
      <div className="text-center sm:text-left w-full">
        <h4 className="text-xl font-semibold text-gray-800 mb-2 break-words">{partner.name}</h4>

        {Array.isArray(partner.address) ? (
          partner.address.map((line, i) => (
            <p key={i} className="text-gray-600 mb-2">
              <i className="fa fa-map-marker text-red-600 mr-1"></i> {line}
            </p>
          ))
        ) : (
          <p className="text-gray-600 mb-2">
            <i className="fa fa-map-marker text-red-600 mr-1"></i> {partner.address}
          </p>
        )}

        {partner.phone && partner.phone.split(',').map((item, index) =>
          <p key={index} className="text-gray-600 mb-2">
            <i className="fa fa-phone text-gray"></i>{" "}
            <a href={`tel:${item}`}>{item}</a>
          </p>
        )}
        {partner.mobile && partner.mobile.split(',').map((item, index) =>
          <p key={index} className="text-gray-600 mb-2">
            <i className="fa fa-mobile text-gray-500 mr-1"></i>{" "}
            <a href={`tel:${item}`}>{item}</a>
          </p>
        )}
        {partner.whatsapp && partner.whatsapp.split(',').map((item, index) =>
          <p key={index} className="text-gray-600 mb-2">
            <i className="fab fa-whatsapp text-green-500 mr-1"></i>{" "}
            <a
              href={`https://wa.me/${item.replace(/\s+/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item}
            </a>
          </p>
        )}
        {partner.telegram && (
          <p className="text-gray-600 mb-2">
            <i className="fab fa-telegram text-blue-500 mr-1"></i>{" "}
            <a
              href={`https://t.me/${partner.telegram.replace(/\s+/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {partner.telegram}
            </a>
          </p>
        )}
        {partner.viber && (
          <p className="text-gray-600 mb-2">
            <i className="fab fa-viber text-purple-500 mr-1"></i>{" "}
            <a
              href={`viber://chat?number=${partner.viber.replace(/\s+/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:underline"
            >
              {partner.viber}
            </a>
          </p>
        )}
        {partner.email && partner.email.split(',').map((item, index) =>
          <p key={index} className="text-gray-600 mb-2 truncate">
            <i className="fa fa-envelope text-gray-500 mr-1"></i>{" "}
            <a href={`mailto:${item}`} target="_blank" rel="noopener noreferrer">
              {item}
            </a>
          </p>
        )}
        {partner.fax && (
          <p className="text-gray-600 mb-2">
            <i className="fa fa-fax text-gray-500 mr-1"></i> {partner.fax}
          </p>
        )}
        {partner.facebook && (
          <p className="text-gray-600 mb-2">
            <i className="fab fa-facebook text-blue-600 mr-1"></i>{" "}
            <a
              href={`https://facebook.com/${partner.facebook}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {partner.displayFacebook?.trim() || partner.facebook}
            </a>
          </p>
        )}
        {partner.twitter && (
          <p className="text-gray-600 mb-2">
            <i className="fab fa-x-twitter text-black mr-1"></i>{" "}
            <a
              href={`https://twitter.com/${partner.twitter}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {partner.twitter}
            </a>
          </p>
        )}
        {partner.instagram && (
          <p className="text-gray-600 mb-2">
            <i className="fab fa-instagram text-pink-500 mr-1"></i>{" "}
            <a
              href={`https://instagram.com/${partner.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {partner.instagram}
            </a>
          </p>
        )}
        {partner.website && (
          <p className="text-gray-600 mb-2 truncate">
            <i className="fa fa-globe text-gray-500 mr-1"></i>{" "}
            <a href={`https://${partner.website}`} target="_blank" rel="noopener noreferrer">
              {partner.website}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default PartnerCard;
